import servicesFeature from "../assets/images/services-feature.jpg";
import accessoriesFeature from "../assets/images/accessories-feature.jpg";

export const featuredItems = [
  {
    id: 1,
    title: "Professional Services",
    description:
      "Expert installation, maintenance, and repair services for your precious lighting fixtures.",
    image: servicesFeature,
    link: "/about#expertise",
    buttonText: "Our Services",
  },
  {
    id: 2,
    title: "Premium Accessories",
    description:
      "Complete your lighting with our selection of high-quality crystal accessories and parts.",
    image: accessoriesFeature,
    link: "/products",
    buttonText: "Browse Accessories",
  },
];
